import firebase from "firebase";
import "firebase/firestore";
import "firebase/auth";

var config = {
  apiKey: "AIzaSyB7A2V5nR0eF_msGXiAZobRt8AwKQWW8m8",
  authDomain: "english-grammar-837d6.firebaseapp.com",
  projectId: "english-grammar-837d6",
  storageBucket: "english-grammar-837d6.appspot.com",
  messagingSenderId: "262648849064",
  appId: "1:262648849064:web:73d126d92eaa58f1d6589d"
};

firebase.initializeApp(config);
firebase.firestore();

export default firebase;
